
import {FormatPrice} from '@/utils'

const SET_LIST = (state,payload) =>{

    state.payload.currentDay = FormatPrice(payload.currentDay / 100)
    state.payload.lastDay = FormatPrice(payload.lastDay / 100)

}

export default {
    SET_LIST,
}